import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "SpecialPage" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = {
  key: 0,
  class: "cms__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingContent = _resolveComponent("LoadingContent")!
  const _component_SpecialPageDetail = _resolveComponent("SpecialPageDetail")!
  const _component_SpecialPageCarousel = _resolveComponent("SpecialPageCarousel")!
  const _component_SpecialPageColumn = _resolveComponent("SpecialPageColumn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingContent, {
          key: 0,
          class: "loadingContent"
        }))
      : (_ctx.view_type === 'detail')
        ? (_openBlock(), _createBlock(_component_SpecialPageDetail, {
            key: 1,
            onCatchTitle: _ctx.setTitle
          }, null, 8, ["onCatchTitle"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!_ctx.CMS_response)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.error), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.CMS_response)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.view_type === 'carousel')
                    ? (_openBlock(), _createBlock(_component_SpecialPageCarousel, {
                        key: 0,
                        cmsResponse: _ctx.CMS_response,
                        viewArea: _ctx.view_area,
                        specialCategory: _ctx.special_category,
                        showMore: _ctx.show_more
                      }, null, 8, ["cmsResponse", "viewArea", "specialCategory", "showMore"]))
                    : (_ctx.view_type === 'column')
                      ? (_openBlock(), _createBlock(_component_SpecialPageColumn, {
                          key: 1,
                          cms_response: _ctx.CMS_response,
                          view_area: _ctx.view_area,
                          special_category: _ctx.special_category
                        }, null, 8, ["cms_response", "view_area", "special_category"]))
                      : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]))
  ]))
}